import { registerUser } from '../../../data/repositories/authRepository.js';

export const registerNewUser = (contactNumber, name, email) => registerUser(contactNumber, name, email);
